import * as React from "react";
import { connect } from "react-redux";
import { Portfolio } from "context/reports/comfort/types";
import { useState as useComfortState } from "../../../context/reports/comfort";
import { Series } from "../../Reports/Utilities/types";
import moment from "moment";
import SeriesFrame from "./components/SeriesFrame";
import { ZonesFrame } from "./components/ZonesFrame";
import { Wrap } from "../../../components/Layout/Page";

interface PortFolioType {
  portfolio?: Portfolio;
}

interface DispatchProps {
  selectedSites: Insite.AppState["betaSelections"]["selectedSites"];
}

type Props = PortFolioType & DispatchProps;

const mapStateToProps = ({ betaSelections }: Insite.AppState) => {
  const { selectedSites } = betaSelections;
  return { selectedSites };
};

const ComfortPortfolio: React.FC<Props> = ({ portfolio, selectedSites }) => {
  const state = useComfortState();

  const categories: String[] = [];
  const series: Series[] = [];

  let siteId = "";
  if (portfolio) {
    Object.keys(portfolio).forEach((key) => {
      if (portfolio[key].series.current.length > 0) {
        siteId = key;
        categories.push(...portfolio[key].series.current.map((c) => c.date));
        series.push({
          name: portfolio[key].name,
          data: portfolio[key].series.current.map((c) => [
            moment(c.date).valueOf(),
            c.totalPctComfort,
          ]),
        });
      }
    });
  }

  const dataTimeRange = {
    from: "",
    to: "",
  };

  if (state.portfolio && state.portfolio[siteId]) {
    dataTimeRange.from = state.portfolio[siteId].summary.current.from;
    dataTimeRange.to = state.portfolio[siteId].summary.current.to;
  }

  return (
    <Wrap>
      <SeriesFrame
        portfolio={state.portfolio}
        portfolioLoading={state.portfolioLoading}
        siteId={siteId}
        rankDir={state.rankDir}
      />

      {selectedSites.length === 1 && (
        <ZonesFrame
          viewBy={state.viewBy}
          rankDir={state.rankDir}
          siteId={siteId}
          current={dataTimeRange}
          zonesLoading={state.zonesLoading}
          zones={state.zones}
        />
      )}
    </Wrap>
  );
};

export default connect(mapStateToProps)(ComfortPortfolio);
